import React from "react"
import ReactDOM from "react-dom/client"
import { Route, createBrowserRouter, RouterProvider, createRoutesFromElements } from "react-router-dom"
import { sitePath } from 'config/globals'

import Dashboard from "pages/Dashboard"
import Login from "pages/Login"
import Logout from "pages/Logout"
import NoPage from "pages/NoPage"

import MuseumDashboard from "pages/museum/Dashboard"
import MuseumArchive from "pages/museum/archive/Archive"
import MuseumBuildingList from "pages/museum/archive/BuildingList"

import MuseumBuildingView from "pages/museum/archive/BuildingView"
import MuseumCraftList from "pages/museum/archive/CraftList"
import MuseumCraftView from "pages/museum/archive/CraftView"
import MuseumDocumentation from "pages/museum/Documentation"

import MuseumCraftRecordList from "pages/museum/craftRecords/CraftRecordList"
import MuseumCraftRecord1 from "pages/museum/craftRecords/CraftRecord1"
import MuseumCraftRecord2 from "pages/museum/craftRecords/CraftRecord2"
import MuseumCraftRecord3 from "pages/museum/craftRecords/CraftRecord3"
import MuseumCraftRecord4 from "pages/museum/craftRecords/CraftRecord4"
import MuseumCraftRecord5 from "pages/museum/craftRecords/CraftRecord5"
import MuseumCraftRecord6 from "pages/museum/craftRecords/CraftRecord6"
import MuseumCraftRecord7 from "pages/museum/craftRecords/CraftRecord7"

import DocumentationBuildingList from "pages/museum/documentation/buildings/BuildingList"
import DocumentationBuildingNew from "pages/museum/documentation/buildings/BuildingNew"
import DocumentationBuildingView from "pages/museum/documentation/buildings/BuildingView"
import DocumentationBuildingEdit from "pages/museum/documentation/buildings/BuildingEdit"
import DocumentationBuildingRecordNew from "pages/museum/documentation/buildings/BuildingRecordNew"
import DocumentationBuildingRecordEdit from "pages/museum/documentation/buildings/BuildingRecordEdit"

import MuseumUserList from "pages/museum/users/UserEdit"
import MuseumUserEdit from "pages/museum/users/UserEdit"
import MuseumUserChangePassword from "pages/museum/users/UserPassword"

import BuildingList from "pages/buildings/BuildingList"
import BuildingNew from "pages/buildings/BuildingNew"
import BuildingView from "pages/buildings/BuildingView"
import BuildingEdit from "pages/buildings/BuildingEdit"

import BuildingRecordList from "pages/buildingRecords/BuildingRecordList"
import BuildingRecordNew from "pages/buildingRecords/BuildingRecordNew"

import CraftRecordList from "pages/craftRecords/CraftRecordList"

import MuseumList from "pages/museums/MuseumList"
import MuseumNew from "pages/museums/MuseumNew"
import MuseumView from "pages/museums/MuseumView"
import MuseumEdit from "pages/museums/MuseumEdit"

import TableDetails from "pages/tables/TableDetails"
import TableEdit from "pages/tables/TableEdit"
import TableNew from "pages/tables/TableNew"

import UserList from "pages/users/UserList"
import UserNew from "pages/users/UserNew"
import UserEdit from "pages/users/UserEdit"
import UserPassword from "pages/users/UserPassword"

import ViewDetails from "pages/views/ViewDetails"

import 'css/bootstrap.min.css'
import 'css/react-pro-sidebar.css'
import 'css/App.css'
import 'css/Typeahead.min.css'


const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path={`/`}>
      <Route index element={<Login />} />
      <Route path="logout" element={<Logout />} />
      
      <Route path="dashboard" element={<Dashboard />} />
      <Route path="views/:viewName" element={<ViewDetails />} />
      <Route path="tables/:tableName" element={<TableDetails />} />
      <Route path="tables/:tableName/edit/:id" element={<TableEdit />} />
      <Route path="tables/:tableName/new" element={<TableNew />} />
      <Route path="users" element={<UserList />} />
      <Route path="users/new" element={<UserNew />} />
      <Route path="users/:id" element={<UserEdit />} />
      <Route path="users/:id/password" element={<UserPassword />} />

      <Route path="museum/:entityId/dashboard" element={<MuseumDashboard />} />
      <Route path="museum/:entityId/archive" element={<MuseumArchive />} />
      <Route path="museum/:entityId/archive/buildings" element={<MuseumBuildingList />} />
      <Route path="museum/:entityId/archive/buildings/:buildingId" element={<MuseumBuildingView />} />
      <Route path="museum/:entityId/archive/buildings/:buildingId/edit" element={<DocumentationBuildingEdit />} />
      <Route path="museum/:entityId/archive/crafts" element={<MuseumCraftList />} />
      <Route path="museum/:entityId/archive/crafts/:craftId" element={<MuseumCraftView />} />
      <Route path="museum/:entityId/documentation" element={<MuseumDocumentation />} />
      
      <Route path="museum/:entityId/documentation/buildings" element={<DocumentationBuildingList />} />
      <Route path="museum/:entityId/documentation/buildings/new" element={<DocumentationBuildingNew />} />
      <Route path="museum/:entityId/documentation/buildings/:buildingId/view" element={<DocumentationBuildingView />} />
      <Route path="museum/:entityId/documentation/buildings/:buildingId/edit" element={<DocumentationBuildingEdit />} />
      <Route path="museum/:entityId/documentation/buildings/:buildingId/new-record" element={<DocumentationBuildingRecordNew />} />
      <Route path="museum/:entityId/documentation/buildings/:buildingId/edit-record/:recordId" element={<DocumentationBuildingRecordEdit />} />

      <Route path="museum/:entityId/documentation/craft-records" element={<MuseumCraftRecordList />} />
      <Route path="museum/:entityId/documentation/craft-records/new" element={<MuseumCraftRecord1 />} />
      <Route path="museum/:entityId/documentation/craft-records/:craftRecordId/edit" element={<MuseumCraftRecord1 />} />
      <Route path="museum/:entityId/documentation/craft-records/:craftRecordId/edit-video" element={<MuseumCraftRecord2 />} />
      <Route path="museum/:entityId/documentation/craft-records/:craftRecordId/edit-context" element={<MuseumCraftRecord3 />} />
      <Route path="museum/:entityId/documentation/craft-records/:craftRecordId/edit-person" element={<MuseumCraftRecord4 />} />
      <Route path="museum/:entityId/documentation/craft-records/:craftRecordId/edit-materials" element={<MuseumCraftRecord5 />} />
      <Route path="museum/:entityId/documentation/craft-records/:craftRecordId/edit-process" element={<MuseumCraftRecord6 />} />
      <Route path="museum/:entityId/documentation/craft-records/:craftRecordId/edit-product" element={<MuseumCraftRecord7 />} />

      <Route path="museum/:entityId/users" element={<MuseumUserList />} />
      <Route path="museum/:entityId/users/:userId/edit" element={<MuseumUserEdit />} />
      <Route path="museum/:entityId/users/:userId/change-password" element={<MuseumUserChangePassword />} />

      <Route path="museums" element={<MuseumList />} />
      <Route path="museums/new" element={<MuseumNew />} />
      <Route path="museums/:id" element={<MuseumView />} />
      <Route path="museums/:id/edit" element={<MuseumEdit />} />

      <Route path="buildings" element={<DocumentationBuildingList />} />
      <Route path="buildings/new" element={<BuildingNew />} />
      <Route path="buildings/:buildingId" element={<BuildingView />} />
      <Route path="buildings/:buildingId/edit" element={<BuildingEdit />} />
      <Route path="buildings/:buildingId/records/new" element={<BuildingRecordNew />} />
      <Route path="buildings/:buildingId/records/:recordId" element={<BuildingRecordNew />} />
      <Route path="building-records" element={<BuildingRecordList />} />

      <Route path="craft-records" element={<CraftRecordList />} />

      <Route from="*" element={<NoPage />} />
    </Route>
  ), {
    basename: sitePath,
  }

)
ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

